<template>
  <form class="form-signin" novalidate>
    <ul v-show="!editMode && step == 0" class="nav nav-tabs nav-fill">
      <li class="nav-item">
        <a
          class="nav-link"
          v-bind:class="{ active: searchMode == 1 }"
          href="#"
          @click.prevent="switchSearch(1)"
        >Suche</a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          v-bind:class="{ active: searchMode == 0 }"
          href="#"
          @click.prevent="switchSearch(0)"
        >Anbieter-Link</a>
      </li>
    </ul>

    <div v-show="editMode || (step < 1 && searchMode == 0)" class="form-group pt-2">
      <label v-show="editMode" for="inputFeedUrl">Anbieter-Link</label>
      <input
        v-model="searchUrl"
        @input="feedUrlChange"
        id="inputFeedUrl"
        class="form-control"
        placeholder="z.B. www.spiegel.de"
        type="url"
        v-bind:required="editMode || searchMode == 0 ? '' : null"
        autofocus
      />
      <div class="invalid-feedback">{{this.invalidFeedbackForUrl}}</div>
    </div>
    <div v-show="!editMode && step < 1 && searchMode == 1" class="form-group pt-2">
      <!--label for="inputFeedSearch">Feed suche</label-->
      <input
        v-model="searchWord"
        id="inputFeedSearch"
        class="form-control"
        placeholder="z.B. Natur"
        autofocus
        v-bind:required="!editMode && searchMode == 1 ? '' : null"
      />
      <div class="invalid-feedback">{{this.invalidFeedbackForFeedSearch}}</div>
    </div>
    <div v-if="step == 1 || step == 2" class="form-group">
      <div class="card">
        <div class="card-header">Wähle einen Feed aus</div>
        <div v-if="step == 1" class="card-body text-center p-1">
          <i class="far fa-grin-stars fa-spin"></i>
        </div>
        <ul class="list-group list-group-flush">
          <button
            v-for="item in searchResult.feeds"
            v-bind:key="item.link"
            v-html="item.title"
            type="button"
            @click="selectedFeed(item.link)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          ></button>
        </ul>
      </div>
    </div>
    <user-menu-button-bar
      v-if="!editMode && step < 2"
      ActionName="Suchen"
      v-on:executeAction="onSearchForFeeds"
      v-on:executeCancel="onExecuteCancel"
    />
    <user-menu-button-bar v-if="step == 2" v-on:executeCancel="onExecuteCancel" />
    <div v-if="editMode || step==3" class="form-group">
      <label for="inputFeedName">Name</label>
      <input
        v-model="newFeed.name"
        @input="validateNameChanged"
        id="inputFeedName"
        class="form-control"
        placeholder="Name"
        required
      />
      <div class="invalid-feedback">{{this.invalidFeedbackForName}}</div>
    </div>
    <user-menu-select-category
      v-if="editMode || step==3"
      v-on:changed="onSelectedCategoryChanged"
      :init="newFeed.categoryId"
    />
    <user-menu-button-bar
      v-if="editMode || step==3"
      :ActionName="this.okButtonName"
      v-on:executeCancel="onExecuteCancel"
      v-on:executeAction="onExecuteAction"
    />
  </form>
</template>

<script>
import UserMenuButtonBar from "./User.Menu.ButtonBar.vue";
import UserMenuSelectCategory from "./User.Menu.SelectCategory.vue";
import moment from "moment";
moment.locale('de');

import { Plugins } from "@capacitor/core";
import "tuer-plugin";

const { TuerPlugin } = Plugins;

export default {
  name: "User.Menu.AddForm",
  components: {
    UserMenuButtonBar,
    UserMenuSelectCategory
  },
  data: function() {
    return {
      newFeed: {
        url: "",
        name: "",
        category: "",
        categoryId: ""
      },
      invalidFeedbackForUrl: "Gib eine gültige URL an",
      invalidFeedbackForFeedSearch: "Gib einen Suchbegriff ein",
      invalidFeedbackForName: "Gib einen Namen an",
      step: 0,
      searchMode: 1,
      searchWord: "",
      searchResult: {
        version: 0,
        feeds: []
      }
    };
  },
  props: {
    callbackExecuteAction: Function,
    initFeed: Object,
    initStep: Number,
    okButtonName: String,
    formTitle: String,
    editMode: Boolean
  },
  computed: {
    searchUrl: {
      // getter
      get: function() {
        return this.searchMode == 0 || this.editMode ? this.newFeed.url : "";
      },
      // setter
      set: function(newValue) {
        this.newFeed.url = newValue;
      }
    }
  },
  methods: {
    switchSearch: function(mode) {
      this.searchMode = mode;
    },
    SetFeedUrlResult: function(response) {
      this.searchResult = response.value;
    },
    SetFeedSearchResult: function(response) {
      let feeds = [];

      response.value.results.forEach(function(item) {
        let entry = new Object();
        entry.link = item.id.replace("feed/", "");
        //es kann der item.id odre item.website stehen
        if (item.website.endsWith(".xml"))
          entry.link = item.website;
        entry.title = item.description;

        let hostname = entry.link;
        if (entry.link.indexOf("//") > -1) {
          hostname = entry.link.split("/")[2];
        } else {
          hostname = entry.link.split("/")[0];
        }

        //find & remove port number
        hostname = hostname.split(":")[0];
        //find & remove "?"
        hostname = hostname.split("?")[0];

        entry.title += " (" + hostname + " - Aktualisiert "+moment(item.lastUpdated, "x").fromNow()+")";
        feeds.push(entry);
      });

      let data = new Object();
      data.version = 1;
      data.feeds = feeds;

      this.searchResult = data;
    },
    onSearchForFeeds: function() {
      this.searchResult.version = 0;
      this.searchResult.feeds = [];

      this.invalidFeedbackForUrl = "Gib eine gültige URL an";
      let nameElement = document.getElementById("inputFeedUrl");
      nameElement.setCustomValidity("");
      let searchElement = document.getElementById("inputFeedSearch");
      searchElement.setCustomValidity("");

      if (this.searchMode == 0) {
        if (this.newFeed.url != "" && this.newFeed.url != "https://") {
          if (!this.newFeed.url.includes("."))
            this.newFeed.url = "www."+ this.newFeed.url + ".de";
        }

        if (!this.newFeed.url.includes("://"))
          this.newFeed.url = "https://" + this.newFeed.url;
      } else this.newFeed.url = "";

      if (this.$el.checkValidity()) {
        this.step = 1;
        let tuerMode = "find";
        let url = this.newFeed.url;
        let processResult = this.SetFeedUrlResult;
        if (this.searchMode == 1) {
          processResult = this.SetFeedSearchResult;
          tuerMode = "echo";
          url =
            "https://cloud.feedly.com/v3/search/feeds?query=" +
            this.searchWord +
            "&count=7&locale=de";
        }
        // axios
        //   .get("https://indie42.de/dist/feedfinder.php?q=" + this.newFeed.url)
        //   .then(response => {
        //     if (response.data.version !== undefined)
        //       this.searchResult = response.data;
        //   })
        //  .catch(error => {
        //    console.log(error);
        //    this.invalidFeedbackForUrl = error;
        //  })
        TuerPlugin.echo({ mode: tuerMode, value: encodeURI(url) })
          .then(result => {
            processResult(result);
            //Wenn eine Versionsnr vorhanden, dann hat die Seite keine Feeds
            if (
              this.searchResult.feeds === undefined ||
              this.searchResult.feeds.length == 0 ||
              this.searchResult.version > 0
            ) {
              this.invalidFeedbackForUrl = "Keine Feeds gefunden";
              this.invalidFeedbackForFeedSearch = "Keine Feeds gefunden";
            }
          })
          .catch(error => {
            if (this.searchMode == 0) {
              this.invalidFeedbackForUrl = error.message;
              this.invalidFeedbackForFeedSearch = "Keine Feeds gefunden";
            } else {
              this.invalidFeedbackForFeedSearch = error.message;
              this.invalidFeedbackForUrl = "Keine Feeds gefunden";
            }
          })
          .finally(() => {
            //Keine Feeds, dann lief etwas schief
            if (
              this.searchResult.feeds === undefined ||
              this.searchResult.feeds.length == 0
            ) {
              nameElement.setCustomValidity(this.invalidFeedbackForUrl);
              searchElement.setCustomValidity(
                this.invalidFeedbackForFeedSearch
              );
              this.$el.checkValidity();
              this.step = 0;
            } else this.step = 2;
          });
      }

      this.$el.classList.add("was-validated");
    },
    selectedFeed: function(aUrl) {
      this.searchMode = -1;
      this.newFeed.url = aUrl;
      this.feedUrlChange();
      this.step = 3;
    },
    onExecuteAction: function() {
      if (this.$el.checkValidity()) {
        this.callbackExecuteAction(this.newFeed);
        //this.$emit("executeCancel");
      }

      this.$el.classList.add("was-validated");
    },
    onExecuteCancel: function() {
      this.$emit("executeCancel");
    },
    onSelectedCategoryChanged: function(aCategory) {
      this.newFeed.category = aCategory.name;
      this.newFeed.categoryId = aCategory.id; // escape(aCategory.toLowerCase());
      this.validateNameChanged();
    },
    feedUrlChange: function() {
      try {
        this.invalidFeedbackForUrl = "Gib eine gültige URL an";
        let nameElement = document.getElementById("inputFeedUrl");
        nameElement.setCustomValidity("");

        var url = new URL(this.newFeed.url);
        var parts = url.hostname.split(".");
        this.newFeed.name = parts[parts.length - 2];
      } catch {
        //console.log(err);
      }
    },
    validateNameChanged: function() {
      let category = this.$store.state.UserFeeds.items.find(
        item => item.id == this.newFeed.categoryId
      );

      let nameElement = document.getElementById("inputFeedName");
      if (category !== undefined) {
        let nameAlreadyExists = category.urls.find(
          feed => feed != this.newFeed && feed.name == this.newFeed.name
        );
        if (nameAlreadyExists !== undefined) {
          let errorText = "Der Name existiert in dieser Kategorie bereits";
          nameElement.setCustomValidity(errorText);
          this.invalidFeedbackForName = errorText;
        } else {
          nameElement.setCustomValidity("");
          this.invalidFeedbackForName = "Gib einen Namen an";
        }
      } else nameElement.setCustomValidity("");

      this.$el.checkValidity();
    }
  },
  created() {
    this.newFeed = this.initFeed;
    this.step = this.initStep;
    if (this.initStep > 2) this.searchMode = -1;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-responsive {
  white-space: normal !important;
  word-wrap: break-word;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 10px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin select {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
